<template>
  <div
    class="selection-opt"
  >
    <div class="highlight white" />
      <div class="resource-label">
        <div
          class="selection-name"
          @click="selection.func(num)"
        >
          {{ selection.name }}
        </div>
        <div
          v-if="RMTSearchType === num"
          class="add-resource-btn"
          :class="(optionsShowing) ? 'btn-on' : 'btn-off'"
          ref="addResourceBtn"
          @click="showAddOptions"
        >
          +
        </div>
      </div>
      <div class="resources-options-rel">
        <div ref="addOptions" v-show="optionsShowing" class="resource-options-holder">
          <ImageUpload @click="hideOptions" v-if="selection.name.toLowerCase() === 'resources'"/>
          <AddAsset @click="hideOptions" v-if="selection.name.toLowerCase() === 'resources'"/>
          <CreateCollection @click="hideOptions" v-if="selection.name.toLowerCase() === 'collections'"/>
        </div>
      </div>
      <div
        ref="highlight"
        class="highlight"
      />
    </div>
  <div class="line" />
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { gsap } from 'gsap';
import ImageUpload from '@/components/rmt/ImageUpload';
import AddAsset from '@/components/rmt/AddAsset';
import CreateCollection from '@/components/rmt/CreateCollection';
import { mapStores } from 'pinia';

export default {
  name: 'SelectionHeaderOption',
  props: ['selection', 'num'],
  components: {
    ImageUpload,
    AddAsset,
    CreateCollection
  },
  data () {
    return {
      optionsShowing: false
    };
  },
  computed: {
    ...mapStores(useRMTStore),
    RMTSearchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
  },
  watch: {
    RMTSearchType (to) {
      this.setHighlight(to);
    }
  },
  mounted () {
    if (this.selection.owner === 'CollectionTab') {
      this.setHighlight(1);
    } else {
      this.setHighlight(0);
    }
  },

  methods: {
    setHighlight (to) {
      let highlight = this.$refs.highlight;
      gsap.to(highlight, {
        scaleX: (to === this.$props.num) ? 1 : 0,
        duration: .5,
        ease: 'power4.inOut'
      });
    },
    showAddOptions (e) {
      e.preventDefault();
      this.optionsShowing = !this.optionsShowing;
      window.addEventListener('click', this.windowClick);
    },
    hideOptions () {
      this.optionsShowing = false;
    },
    windowClick (e) {
      if (this.$refs.addOptions != null && this.$refs.addOptions.contains(e.target)) { return; }
      if (this.$refs.addResourceBtn != null && this.$refs.addResourceBtn.contains(e.target)) { return; }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.optionsShowing = false;
      window.removeEventListener('click', this.windowClick);
    },
  }
};
</script>

<style scoped>
.white {
  background-color: white !important;
}
.btn-on {
  background-color: #72b9f3 !important;
}
.btn-off {
  background-color: whitesmoke !important;
}
.header-option-holder {
  height: 60px;
  display: flex;
  align-items: center;
  user-select: none;
}
.selection-opt {
  cursor: pointer;
  width:100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.resource-label {
  width: 100%;
  height: 30px;
  text-transform: Uppercase;
  font-size: .75em;
  font-weight: bold;
  letter-spacing: .05em;
  display: flex;
  justify-content: space-between;

}
.highlight {
  height: 4px;
  width: 100%;
  background-color: #9c9c9c;
}
.line {
  height: 1px;
  background-color: #9c9c9c;
  flex-wrap: wrap;
}
.selection-name {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  transition: background-color .1s;
}
.selection-name:hover {
  background-color: whitesmoke;
}
.add-resource-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  font-size: 1.4em;
  background-color: whitesmoke;
}
.add-resource-btn:hover {
  background-color: #d9d9d9 !important;
}
.resource-options-holder {
  position: absolute;
  width: 50%;
  box-shadow: 2px 4px 43px -32px #a6b5a6;
  z-index: 200;
  user-select: none;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
}
.resource-add-option {
  height: 30px;
  cursor: pointer;
  background-color: #72b9f3;
  color: white;
  width: 160px;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: .8em;
  font-weight: 900;
  letter-spacing: .07em;
  transition: background-color .1s;
}
.resource-add-option:hover {
  background-color: #58a0da;
}
.resources-options-rel {
  width: 100%;
}
</style>
